export default __webpack_public_path__ + "static/media/ML.357357fd.png";